/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchTerm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function SearchTerm({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Tags/Content/SearchTerm",
  onChange
  
}) {
let tagsPickerEditTagOpenValueData = fromData.useDataValue({ viewPath,
context: 'tags_picker',
path: 'edit_tag.open',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let tagsPickerSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'tags_picker',
path: 'search_term',
})
let tagsPickerSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'tags_picker',
path: 'search_term',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 marginBottom={0}
 autoFocus={true}
 data="tags_picker.edit_tag.open"
 disabled={tagsPickerEditTagOpenValueData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 borderBottomLeftRadius={0}
 borderWidth={0}
>
{childProps => (
<React.Fragment>
<TysiaIconSearch
{...childProps}
  viewPath={`${viewPath}/TysiaIconSearch`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral400}
/>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 data="tags_picker.search_term"
 value={tagsPickerSearchTermValueData}
 onChange={tagsPickerSearchTermChangeData}
 placeholder="Type to add new tag"
/>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}